/**
 * Styles partagés entre la bulle utilisateur de `MessageBubble` et la bulle de
 * réponse `ask_user` : les deux doivent rester visuellement identiques.
 */
export const USER_MESSAGE_ROOT_CLASS = 'max-w-[min(100%,48rem)] items-end';

export const ASSISTANT_MESSAGE_ROOT_CLASS = 'max-w-[min(100%,48rem)] items-start';

export const USER_MESSAGE_CONTENT_CLASS = [
  'w-fit px-0 py-0 shadow-none',
  'ml-auto max-w-[min(70%,26rem)] !rounded-[1.5rem] bg-secondary px-5 !py-2 text-foreground',
].join(' ');

export const ASSISTANT_MESSAGE_CONTENT_CLASS = [
  'w-fit px-0 py-0 shadow-none',
  'border-transparent bg-transparent text-foreground',
  // Toujours rogné (un contenu trop large ne déborde pas de la colonne), mais avec une marge
  // suffisante pour l'ombre des cartes (document, recherche) que `overflow-hidden` coupait.
  'overflow-clip [overflow-clip-margin:3rem]',
].join(' ');

export const USER_MESSAGE_TEXT_CLASS = 'whitespace-pre-wrap text-base leading-7';
